import { statusCodes } from "../../../constants";
import { api } from "../api";

import { UserType } from "../../../constants/settings";

export const storage = window.sessionStorage;

export const sessionService = {
  hasToken,
  createSession,
  sessionFromStore,
  setSessionToStore,
  getSession,
  clearSession,
  getSearchParams,
  setSearchParams,
  getBookingMode,
  setBookingMode,
  getUserData,
  setUserData,
  getPassengerData,
  setPassengerData,
  logout,
  getUserStatus,
  // updateUserData,
  setCulture,
  getCulture,
  setCurrency,
  getCurrency,
  logging,
};

function hasToken() {
  return !!sessionFromStore();
}

function sessionFromStore() {
  return sessionStorage.sid ? sessionStorage.sid : undefined;
  // const cookies = document.cookie.split(';');
  // const tokenCookie = cookies.find(cookie => cookie.trim().startsWith('token='));
  // if (tokenCookie) {
  //   return tokenCookie.split('=')[1];
  // }
  // return undefined;
}

function setSessionToStore(token) {
  if (token) {
    sessionStorage.sid = token;
    return true;
  } else {
    sessionStorage.removeItem("sid");
    return false;
  }
  // document.cookie = `token=${token};path=/`;
}

async function getSession() {
  const token = sessionFromStore();
  if (!token) {
    return await createSession()
  }

  setSessionToStore(token);
  try {
    return await validateSession();
  }
  catch (err) {
    return await createSession()
  }
}

function setSearchParams(params) {
  storage.setItem("searchParams", JSON.stringify(params));
}

function getSearchParams() {
  return safeParseItem("searchParams") || {};
}

function setBookingMode(mode) {
  const modeData = mode ? JSON.stringify(mode) : null;
  storage.setItem("bookingMode", modeData);
}

function getBookingMode() {
  return safeParseItem("bookingMode") || { mode: "Booking" };
}

function setUserData(data) {
  if(data) {
    data.lastModified = new Date();
  }
  const userData = data ? JSON.stringify(data) : null;
  storage.setItem("userData", userData)
}


function getUserData() {
  return safeParseItem("userData") || { userType: UserType.guest };
}

function setPassengerData(data) {
  const paxData = data ? JSON.stringify(data) : null;
  storage.setItem('passengerData', paxData);
}

function getPassengerData() {
  return safeParseItem("passengerData");
}

// storage.setItem(key, null) coerces to the literal string "null", so a
// pre-parse truthiness check on the raw string isn't enough to catch a
// cleared value — parse first, then let callers apply their own default.
function safeParseItem(key) {
  const raw = storage.getItem(key);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (err) {
    storage.removeItem(key);
    return null;
  }
}

function setCulture(culture) {
  if(culture) storage.setItem("culture", culture);
}

function getCulture() {
  let culture = storage.getItem("culture");
  if(!culture) culture = "en-US";
  return culture;
}

function setCurrency(currency) {
  if(!currency) currency = ''
  storage.setItem("currency", currency);
}

function getCurrency() {
  return storage.getItem("currency");
}

async function validateSession() {
  const result = await api.getFetch("api/session/validate", undefined, async response => {
    if(response.status === statusCodes.BAD_REQUEST || response.status === statusCodes.FORBIDDEN) {
      const createResult = await createSession();
      return createResult;
    }
  });
  return result;
}

async function createSession() {
  // invalid current session
  sessionStorage.removeItem("sid");
  // document.cookie = 'token=;Path=/;Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

  try {
    const { token } = await api.getSession("api/session");
    setSessionToStore(token);
    return token;
  }
  catch(err) {
    console.error('Error creating session: ', err);
    return Promise.reject(err);
  }
}

function clearSession() {
  return api.postFetch(`api/session/clear`)
}

function logout() {
  return api.postFetch(`api/session/logout`, undefined)
    .then(() => {
      let userData = getUserData();
      if(userData) {
        userData = {...userData, loggedIn: false, permissions: [] };
        setUserData(userData);
      }
      return userData;
    })
}

function getUserStatus() {
  return api.getFetch(`api/session/userStatus`)
}

function logging(data) {
  // Logging is best-effort only. Never propagate failures to callers.
  return api.post('api/session/logging', data).catch(() => null)
}
